class AccountingModel {
    constructor({
        id = "",
        value = "",
        name = "",
        message = "",
        showLabel = "",
        deleted = false,
        position = "",
        requiredDocumentation = [],
    } = {}) {
        this.id = id;
        this.value = value;
        this.name = name;
        this.message = message;
        this.showLabel = showLabel;
        this.deleted = deleted;
        this.position = position;
        this.requiredDocumentation = requiredDocumentation;
    }

    static getAttributes(filter = null) {
        const attributes = {
            id: {
                'label': 'ID',
                'sortable': false,
                'sortField': 'id',
                'value': (item) => item.id || "",
            },
            value: {
                'label': 'Kontonummer',
                'sortable': false,
                'sortField': 'value',
                'value': (item) => item.value || "",
                'thClass': 'text-start',
            },
            name: {
                'label': 'Namn',
                'sortable': false,
                'sortField': 'name',
                'value': (item) => item.name || "",
                'thClass': 'text-start',
            },
            message: {
                'label': 'Beskrivning',
                'sortable': false,
                'sortField': 'message',
                'value': (item) => item.message || "",  
            },
            showLabel: {
                'label': 'Visa etikett',
                'sortable': false,
                'sortField': 'showLabel',
                'value': (item) => item.showLabel || "",
            },
            position: {
                'label': 'Ordningsföljd',
                'sortable': false,
                'sortField': 'position',
                'value': (item) => item.position || "",
            },
            requiredDocumentation: {
                'label': 'Nödvändiga underlag',
                'sortable': false,
                'sortField': 'requiredDocumentation',
                'value': (item) => {
                    const docs = Array.isArray(item.requiredDocumentation)
                    ? item.requiredDocumentation
                    : (typeof item.requiredDocumentation === 'string' && item.requiredDocumentation.length > 0
                        ? JSON.parse(item.requiredDocumentation)
                        : []);
                    return docs.length ? docs.join(', ') : '';
                },
                'thClass': 'text-start',
            },
        };

        return attributes;
    }
}

export default AccountingModel;